import { Episode } from './../../models';
import { EcomicService } from './../../service/comics/ecomic.service';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
declare const swal: any;
declare var $: any;

@Component({
  selector: 'app-e-comic-episode',
  templateUrl: './e-comic-episode.component.html',
  styleUrls: ['./e-comic-episode.component.css']
})
export class EComicEpisodeComponent implements OnInit {
  Ecomicepisodecol: AngularFirestoreCollection<Episode>;
  Ecomicepisode: Observable<Episode[]>;
  showseason: any = true;
  showseries: any = true;
  seasons: any;
  eseries: any;
  seasonoption: any = 'All';
  seriesoption: any = 'All';
  selectedseries: any = 'All';
  selectedseason: any = 'All';
  selectedstatus: any = 'All';
  id:any;
  constructor(private afs: AngularFirestore, private comicService: EcomicService) { }

  async ngOnInit() {
    this.showseries = false;
    const collection = await this.afs.collection('Ecomicseries');
    await collection.valueChanges().subscribe(seriess => {
      this.eseries = seriess;
      if(this.eseries.length < 1) {this.seriesoption = ''; }
      this.showseries = true;
    });
    this.Ecomicepisodecol = this.afs.collection('Ecomicepisode',res =>{
      return res.orderBy('createdAt', 'desc');
    });
    this.Ecomicepisode = this.Ecomicepisodecol.valueChanges();
  }
    async getseasons(id) {
      id == 'All' ? this.selectedseason = 'All' : '';
      this.showseason = false;
      try {
        this.comicService.getseasons(id).then(eseasonsdata => {
          // subscribing the data from the service
          eseasonsdata.subscribe(eseasons => {
            this.seasons = eseasons;
            this.seasonoption = this.seasons.length < 1 ? '' : 'All';
            this.showseason = true;
          });
        });
      } catch (error) {
        this.showseason = true;
        console.log(error);
      }
  }
  filterdata () {
    const type = this.selectedseries != 'All' ? 'comic_series' : 'status';
    const content = this.selectedseries != 'All' ? this.selectedseries : this.selectedstatus;
    this.Ecomicepisodecol = this.afs.collection('Ecomicepisode', res => {
      if (this.selectedseason == 'All' && this.selectedseries == 'All' && this.selectedstatus == 'All') {
        return res.orderBy('createdAt', 'desc');
      } else if (this.selectedseason != 'All' && this.selectedseries != 'All' && this.selectedstatus != 'All') {
        console.log('fine');
        return res.orderBy('createdAt', 'desc').where('status', '==', this.selectedstatus)
                  .where('comic_seasons', '==', this.selectedseason)
                  .where('comic_series', '==', this.selectedseries);
      } else if (this.selectedstatus != 'All' && this.selectedseries != 'All') {
        return res.orderBy('createdAt', 'desc').where('status', '==', this.selectedstatus).where('comic_series', '==', this.selectedseries);
       } else if (this.selectedseason != 'All' && this.selectedseries != 'All') {
        return res.orderBy('createdAt', 'desc').where('comic_seasons', '==', this.selectedseason).where('comic_series', '==', this.selectedseries);
       } else {
        return res.orderBy('createdAt', 'desc').where(type, '==', content);
       }
    });
    this.Ecomicepisode = this.Ecomicepisodecol.valueChanges();
  }
  delete(id) {
    console.log(id);
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    $('#DeleteModal').modal('hide');
      this.afs.doc('/Ecomicepisode/'+this.id).delete().then(function () {  
        swal('Deleted!', 'Your List has been deleted.', 'success');
      }).catch(function(error){
        swal('Error!', error, 'error');
        console.error("error in removing document:",error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/E-comics/e-comic-episode/e-comic-episode.component.ts